import * as React from "react";
import {Grid, Tab, Tabs} from "@material-ui/core";
import {ContentHeader} from "../ui-base/content-header";
import {useEffect, useState} from "react";
import {ManuscriptModel} from "../../models/manuscript.model";
import {AuthorService} from "../../services/author.service";
import {toggleLoader} from "../../store/global/global-slice";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {ProfileDashboardComponent} from "../dashboard/profile-dashboard-component";
import {QuoteDashboardComponent} from "../dashboard/quote-dashboard-component";
import {NewBookShort} from "./books/new-book-short";
import {EmptyBookShort} from "./books/empty-book-short";
import {ApplicationShort} from "./books/application-short";
import {StyledButton} from "../ui-base/button";
import {CustomTabPanel} from "../ui-base/tab-panel";
import {quotes} from "../../data/quotes";
import {PublisherApplicationModel} from "../../models/publisher/publisher-application.model";
import {PaginationModel} from "../../models/pagination.model";
import {useTranslation} from "react-i18next";

const AuthorDashboard = () => {
    const history = useHistory();
    const [manuscripts, setManuscripts] = useState<PaginationModel<ManuscriptModel[]>>(null);
    const [manuscriptsLoaded, setManuscriptsLoaded] = useState<boolean>(false);
    const [applications, setApplications] = useState<PaginationModel<PublisherApplicationModel[]>>(null);
    const [applicationsLoaded, setApplicationsLoaded] = useState<boolean>(false);
    const [tabActive, setTabActive] = React.useState(0);
    const [quote, setQuote] = React.useState<{description: string, author: string}>(null);
    const dispatch = useDispatch();
    const { t } = useTranslation(['author', 'common']);

    useEffect(() => {
        dispatch(toggleLoader(true));

        const loadManuscripts = async () => {
            const res = await AuthorService.getMyManuscripts(0, 4);

            setManuscripts(res);
            setManuscriptsLoaded(true);
        }

        const loadApplications = async () => {
            const res = await AuthorService.getMyApplications(0, 4);

            setApplications(res);
            setApplicationsLoaded(true);
        }

        loadManuscripts();
        loadApplications();

        const quotesLength = quotes.length;
        const min = Math.ceil(0);
        const max = Math.floor(quotesLength - 1);
        const randomNumber = Math.floor(Math.random() * (max - min)) + min;

        setQuote({
            author: t('dashboard.quoteAuthor' + randomNumber.toString()),
            description: t('dashboard.quoteDesc' + randomNumber.toString())
        });

    }, [dispatch, t]);

    useEffect(() => {
        if (manuscriptsLoaded && applicationsLoaded) {
            dispatch(toggleLoader(false));
        }
    }, [manuscriptsLoaded, applicationsLoaded, dispatch])

    return (
        <Grid container direction={"column"}>

            <Grid item container direction={"row"} spacing={2}>
                <Grid item sm={12} md={6}>
                    <ProfileDashboardComponent
                        title={t('dashboard.title')}
                        description={t('dashboard.desc')}
                        linkTitle={t('dashboard.linkTitle')}
                        link={'/author/edit-profile'}
                    />
                </Grid>

                <Grid item sm={12} md={6}>
                    {quote &&
                    <QuoteDashboardComponent
                        description={quote.description}
                        author={'- ' + quote.author}
                    />
                    }
                </Grid>
            </Grid>

            <Grid item container direction={"column"} spacing={2}>
                <Grid item>
                    <ContentHeader id="manuscripts-header" title={t('dashboard.headerTitle1')}/>
                </Grid>

                <Grid item>
                    <Tabs value={tabActive} onChange={(event, newValue) => { setTabActive(newValue) }}>
                        <Tab label={t('dashboard.tabTitle1')}/>
                        <Tab label={t('dashboard.tabTitle2')}/>
                    </Tabs>
                    <CustomTabPanel value={tabActive} index={0}>
                        <Grid item container direction={"row"} spacing={2}>
                            {manuscripts?.results?.map((manuscript, index) => (
                                <NewBookShort key={manuscript.id} manuscript={manuscript}/>
                            ))}

                            {manuscripts?.results?.length === 0 && manuscriptsLoaded &&
                                <EmptyBookShort
                                    title={t('dashboard.noManuscriptsTitle')}
                                    description={t('dashboard.noManuscriptsDesc')}
                                    showButton={true}
                                />
                            }
                        </Grid>

                        {manuscripts?.next &&
                            <Grid container direction={"row"} justifyContent={"center"} style={{marginTop: '30px'}}>
                                <StyledButton type={"button"} color={"transparent"} onClick={() => {
                                    history.push('/author/books');
                                }}>
                                    {t('common:showAll')}
                                </StyledButton>
                            </Grid>
                        }
                    </CustomTabPanel>
                    <CustomTabPanel value={tabActive} index={1}>
                        <Grid item container direction={"row"} spacing={2}>
                            {applications?.results?.map((application, index) => (
                                <ApplicationShort application={application} key={index}/>
                            ))
                            }

                            {applications?.results?.length === 0 && manuscriptsLoaded &&
                            <EmptyBookShort
                                title={t('dashboard.noApplicationTitle')}
                                description={t('dashboard.noApplicationDesc')}
                                showButton={false}
                            />
                            }
                        </Grid>
                    </CustomTabPanel>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default AuthorDashboard;
